import { CheckCircleFilled } from "@ant-design/icons";
import { Button, Icon } from "Components";
import { DIFFICULTY_COLOR } from "../../PhishingManager.constants";
import { joinItems, capitalize } from "PhishingManager/utils";
import "./templatecard.scss";
import { useTranslation } from "react-i18next";

export interface Template {
	value: string | number;
	label: string;
	categories: string[];
	languages: string[];
	difficulty: string;
	img: string;
}

type TemplateCardProps = {
    template: Template;
    selected: boolean;
    onSelect: (id: string | number | null) => void;
    isLibrary?: boolean;
};

export default function TemplateCard({ template, selected, onSelect, isLibrary = false }: TemplateCardProps) {
  const rawDiff = (template?.difficulty || 'Beginner').trim();
  const diffKey = capitalize(rawDiff);

  const diff = (isLibrary && diffKey === 'Beginner')
    ? { bg: '#E6F7FD', color: '#006CA3' }
    : (DIFFICULTY_COLOR[diffKey] || DIFFICULTY_COLOR.Beginner);

    const category = joinItems(template?.categories || []);
    const { t } = useTranslation();

    return (
        <div className="cs-template-card-wrapper">
            <div className="cs-template-img">
                <div className="cs-card-logo-badge">
                <Icon type="viewerLogo" />
                </div>
                <img src={template?.img || "./placeholderImage.png"} alt={template.label} className="cs-image-cover" />
                <span className="cs-image-word-cover" style={{ background: diff.bg, color: diff.color }}>
                    {template.difficulty}
                </span>
                {selected && (
                    <div className="cs-selected-checkbox">
                        <CheckCircleFilled className="text-white fsx-16" />
                    </div>
                )}
            </div>

            <div className="cs-template-card">
                <div className="cs-template-card-title">
                    {template.label}
                </div>
                <div className="cs-template-card-category">
                    {category}
                </div>
            </div>

            <Button shape="round" type="primary" onClick={(e) => {
                e.stopPropagation();
                selected ? onSelect(null) : onSelect(template.value);
            }}>{selected ? t(`phishingManager.campaignSetup.step1.templateCard.selected`) : t(`select`)}</Button>
        </div>
    );
}